

















import {Vue, Component} from 'vue-property-decorator';
import {Mutation, Getter, namespace} from 'vuex-class';
import {previewImage} from '../util/util';

const ImageFilterMutation = namespace('imageFilter', Mutation);
const ImageFilterGetter = namespace('imageFilter', Getter);

@Component
export default class ImageNavigator extends Vue {
  @ImageFilterMutation('selectImage') private selectImage: (image: File) => void;
  @ImageFilterGetter('availableImages') private availableImages: File[];

  private thumbnails: {[key: string]: string} = {};

  private mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'imageFilter/addImage') {
        this.addThumbnail(mutation.payload);
      }
    });
  }

  private addThumbnail(file: File) {
    previewImage(file).then(image => this.$set(this.thumbnails, file.name, image));
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/image-filter/image-navigator/image-navigator.vue